import {obtenerFechaEstandarCheckIn} from "../Funciones/obtenerFechaEstandarCheckIn";
import {obtenerFechaEstandarCheckOut} from "../Funciones/obtenerFechaEstandarCheckOut";
import {fire} from "../../fire";
import {collection, or, query, where} from "firebase/firestore";
import {obtenerColeccionQuery} from "../../Servicios/BD/obtenerColeccionQuery";
import {COLECCIONRESERVAS, FECHACHECKIN, FECHACHECKOUT} from "../Constantes";

export const obtenerReservasEntreFechas = async ({fechaCheckIn, fechaCheckOut}) => {

    let fechaCheckInStandar = obtenerFechaEstandarCheckIn(fechaCheckIn)
    let fechaCheckOutStandar = obtenerFechaEstandarCheckOut(fechaCheckOut)

    let col = collection(fire, COLECCIONRESERVAS)
    let q = query(col, or(where(FECHACHECKIN, '>=', fechaCheckInStandar), where(FECHACHECKOUT, '>=', fechaCheckInStandar)))

    let dox = await obtenerColeccionQuery(q)
    let arrReservas = dox.data
    // console.log(arrReservas)

    let arrResevasValidadas = []
    for (let i = 0; i < arrReservas.length; i++) {
        let reserva = arrReservas[i]
        if (
            (fechaCheckInStandar >= reserva[FECHACHECKIN] && fechaCheckInStandar <= reserva[FECHACHECKOUT]) ||
            (fechaCheckOutStandar >= reserva[FECHACHECKIN] && fechaCheckOutStandar <= reserva[FECHACHECKOUT])
        ) {
            arrResevasValidadas.push(reserva)
        }
    }

    return arrResevasValidadas

}